import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  return <header className="w-full bg-white fixed top-0 z-50 py-5 shadow-sm" data-id="element-1000">
      <div className="container mx-auto px-6 flex justify-between items-center" data-id="element-1001">
        <div className="font-medium text-xl text-black flex items-center" data-id="element-1002">
          <a href="https://www.explorandoconfran.com/" className="block" data-id="element-1003">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pC2XeSTdVfAtEqxLSTomGj/jpgexplorandoconfran.jpg" alt="explorandoconfran logo" className="h-12" data-id="element-1004" />
          </a>
        </div>
        {/* Mobile Menu Button */}
        <button className="md:hidden focus:outline-none" onClick={() => setMenuOpen(!menuOpen)} data-id="element-1005">
          {menuOpen ? <XIcon className="h-6 w-6 text-black" data-id="element-1006" /> : <MenuIcon className="h-6 w-6 text-black" data-id="element-1007" />}
        </button>
      </div>
      {/* Mobile Navigation - Empty but keeping structure */}
      {menuOpen && <div className="md:hidden bg-white py-5 px-6 shadow-inner" data-id="element-1008">
          {/* Navigation links removed as requested */}
        </div>}
    </header>;
}